import { render, staticRenderFns } from "./UserTable.vue?vue&type=template&id=0f58ff80&scoped=true&"
import script from "./UserTable.vue?vue&type=script&lang=ts&"
export * from "./UserTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f58ff80",
  null
  
)

export default component.exports